import { DisableMetricSyncComponent, DisableMetricSyncModal } from "./components/disable-metric-sync/disable-metric-sync.modal.component";
import core from "@gtmhub/core/module";
import insightsCode from "@gtmhub/insights/insights-core.module";
import { MetricCtrl } from "./controllers/metric";
import { MetricService } from "./services/metric.service";
import { UpdateMetricCtrl } from "./controllers/update-metric";
import { DynamicMetricCtrl } from "./controllers/dynamic-metric";
import { EditDynamicMetricCtrl } from "./controllers/edit-dynamic-metric";
import { MetricFormCtrl } from "./controllers/metric-form";
import { MetricLinkService } from "./services/metric-link.service";
import { metricValue } from "./filters/filters";
import { CascadingMetricFormComponent, CascadingMetricFormModal } from "./components/cascading-metric-form/cascading-metric-form.component";
import { CascadingMetricContributorComponent } from "./components/cascading-metric-form/cascading-metric-contributor.component";
import { CascadingMetricValuesAffixInputComponent } from "./components/cascading-metric-values-affix-input/cascading-metric-values-affix-input.component";

const mod = angular.module("metrics", [core, insightsCode]);

mod.controller("MetricCtrl", MetricCtrl);
mod.controller("UpdateMetricCtrl", UpdateMetricCtrl);
mod.controller("MetricFormCtrl", MetricFormCtrl);
mod.controller("DynamicMetricCtrl", DynamicMetricCtrl);
mod.controller("EditDynamicMetricCtrl", EditDynamicMetricCtrl);

mod.component("disableMetricSync", DisableMetricSyncComponent);
mod.component("cascadingMetricForm", CascadingMetricFormComponent);
mod.component("cascadingMetricContributor", CascadingMetricContributorComponent);
mod.component("cascadingMetricValuesAffixInput", CascadingMetricValuesAffixInputComponent);

mod.service("MetricService", MetricService);
mod.service("MetricLinkService", MetricLinkService);
mod.service("DisableMetricSyncModal", DisableMetricSyncModal);
mod.service("CascadingMetricFormModal", CascadingMetricFormModal);

mod.filter("metricValue", metricValue);

export default mod.name;
